
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: '30px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '20px 0',
      width: '100%'
    },
  },
  title: {
    margin: '0 0 19px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 0 10px',
      textAlign: 'center'
    },
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    flexWrap: 'wrap',  
  },
  input: {
    width: '255px',
    [theme.breakpoints.down('sm')]: {
      width: '100%', 
      marginBottom: '10px', 
    },
  },
}));
